import { render, staticRenderFns } from "./machine-owner-item.vue?vue&type=template&id=38e13a52&"
import script from "./machine-owner-item.vue?vue&type=script&lang=js&"
export * from "./machine-owner-item.vue?vue&type=script&lang=js&"
import style0 from "./machine-owner-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports